import { useState } from "react";
import { Info, ChevronDown } from "lucide-react";
import { ANALYTICS_NOTE, FULL_DISCLAIMER, AI_DISCLAIMER, AI_PERFORMANCE_NOTE } from "@/lib/site";

/** Compact inline note for pages showing analytics, charts or AI outputs. */
export const AnalyticsNote = ({ className = "" }) => (
  <div data-testid="analytics-note" className={`flex items-start gap-3 rounded-md border border-white/[0.08] bg-white/[0.02] px-4 py-3 ${className}`}>
    <Info className="w-3.5 h-3.5 text-ai-accent mt-0.5 shrink-0" />
    <p className="text-xs text-zinc-400 leading-relaxed">{ANALYTICS_NOTE}</p>
  </div>
);

/** Expandable full disclaimer — keeps design clean while remaining accessible. */
export function ExpandableDisclaimer({ testid = "expandable-disclaimer" }) {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={testid} className="rounded-md border border-white/[0.08] bg-white/[0.015]">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid={`${testid}-toggle`}
        className="w-full flex items-center justify-between gap-4 px-4 py-3.5 text-left"
      >
        <span className="label-xs text-zinc-400">Disclaimer &amp; Regulatory Status</span>
        <ChevronDown className={`w-4 h-4 text-zinc-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid={`${testid}-body`} className="px-4 pb-5 space-y-3 border-t border-white/[0.06] pt-4">
          <p className="text-xs text-zinc-400 leading-relaxed">{FULL_DISCLAIMER}</p>
          <p className="text-xs text-zinc-400 leading-relaxed">
            <span className="text-zinc-300">AI &amp; Analytics Disclaimer: </span>{AI_DISCLAIMER}
          </p>
          <p className="text-xs text-zinc-500 leading-relaxed">{AI_PERFORMANCE_NOTE}</p>
        </div>
      )}
    </div>
  );
}
